import type { SVGProps } from 'react';
const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 23a10 10 0 1 0 0-20 10 10 0 0 0 0 20M11.75 9.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-.312 2.5h1.874c.52 0 .938.418.938.938v3.437h.313c.519 0 .937.418.937.938 0 .519-.418.937-.937.937h-3.126a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938h.937v-2.5h-.937a.935.935 0 0 1-.938-.937c0-.52.418-.938.938-.938"
    />
  </svg>
);
export default SvgInfoCircle;
